export default class {
    constructor() {
        for (let form of document.querySelectorAll('.js-form')) {

            const btn = form.querySelector('.btn');
            

            btn.addEventListener('click', async () => {
                const formData = new FormData(form);
                const dataArray = Array.from(formData.entries());

                dataArray.push(["action", "send_telegram_message"]);
                dataArray.push(["nonce", telegramAjax.nonce]);

                console.log(dataArray);

                this.setButtonLoading(btn, true);

                // 
                try {
                    const response = await fetch(telegramAjax.ajax_url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams(dataArray)
                    });
        
                    const result = await response.json();
        
                    if (result.success) {
                        console.log(result.data, 'success');
                        form.reset();
                    } else {
                        console.log(result.data, 'error');
                    }
                } catch (error) {
                    console.error('Error:', error);
                    console.log('Ошибка отправки. Попробуйте позже.', 'error');
                } finally {
                    this.setButtonLoading(btn, false);
                }


            })
        }
    }


    setButtonLoading(submitBtn, isLoading) {
        if (isLoading) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="spinner"></span> Отправка...';
        } else {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Отправить';
        }
    }
}